import { IShapeToolbarConfig } from "@dhx/ts-diagram";
import { addIcon, getIcon, removeIcon } from "./icons";

export const orgShapeToolbar: IShapeToolbarConfig[] = [
	{
		id: "add",
		content: addIcon,
		check: item => !item.assistant && !item.partner,
	},
	{
		id: "menu",
		content: "<i class='dxi dxi-dots-vertical'>",
		check: item => !item.assistant && !item.partner,
	},
	{
		id: "remove",
		content: removeIcon,
		check: item => item.assistant || item.partner,
		css: () => "dhx_icon_remove",
	},
];

export const mindmapShapeToolbar: IShapeToolbarConfig[] = [
	{
		id: "add",
		content: addIcon,
		check: item => item.$level !== 0,
	},
	{
		id: "addLeft",
		content: addIcon,
		check: item => item.$level === 0,
	},
	{
		id: "addRight",
		content: addIcon,
		check: item => item.$level === 0,
	},
	{
		id: "remove",
		content: removeIcon,
		check: item => !!item.$parent,
		css: () => "dhx_icon_remove",
	},
];

export const defaultShapeToolbar: IShapeToolbarConfig[] = [
	{
		id: "lineTextAutoPositionEnable",
		content: () => getIcon("format-text-rotation-angle-up"),
		check: item =>
			item.$item.getBaseType() === "line" &&
			item.$subSelected &&
			item.title.text.find(i => i.id === item?.$subSelected)?.autoPosition,
	},
	{
		id: "lineTextAutoPositionDisable",
		content: () => getIcon("format-text-rotation-none"),
		check: item =>
			item.$item.getBaseType() === "line" &&
			item.$subSelected &&
			!item.title.text.find(i => i.id === item?.$subSelected)?.autoPosition,
	},
	{
		id: "addLineText",
		content: () => getIcon("add-line-text"),
		check: item => item.$item.getBaseType() === "line" && !item.$subSelected,
	},
	{
		id: "addColumnLast",
		content: "<i class='dxi dxi-table-column-plus-after'>",
		check: item => item.$item.getBaseType() === "swimlane",
	},
	{
		id: "addRowLast",
		content: "<i class='dxi dxi-table-row-plus-after'>",
		check: item => item.$item.getBaseType() === "swimlane",
	},
	{
		id: "copy",
		content: () => getIcon("duplicate"),
		check: item => item.$item.getBaseType() !== "line" && !item.$group,
	},
	{
		id: "connect",
		content: () => getIcon("connect"),
		check: item => item.$item.getBaseType() === "shape",
		css: item => (item.$connectMode ? "dhx_active_icon" : ""),
	},
	{
		id: "remove",
		content: removeIcon,
		css: () => "dhx_icon_remove",
		check: item => !item.$selectedPoint,
	},
	{
		id: "removePoint",
		content: removeIcon,
		check: item => item.$item.getBaseType() === "line" && item.$selectedPoint,
		css: item => (item.$connectMode ? "dhx_active_icon" : ""),
	},
];
